import { createAction } from '@reduxjs/toolkit';
import { History } from 'history';
import { Space } from 'api/space/space';

export interface CreateSpacePayload
  extends Omit<Space, 'project' | 'spaceTabs'> {
  project: { projectId: number };
}

export const createSpaceSagaAction = createAction<Partial<CreateSpacePayload>>(
  'spaces/createSpaceSagaAction',
);

export const fetchSpaceDetailSagaAction = createAction<number>(
  'spaces/fetchSpaceDetailSagaAction',
);

export interface DeleteSpacePayload {
  spaceId: number;
  history: History;
  redirectURL: string;
}

export const deleteSpaceSagaAction = createAction<DeleteSpacePayload>(
  'spaces/deleteSpaceSagaAction',
);

export interface UpdateSpacePayload {
  spaceId: number;
  spaceName: string;
}

export const editSpaceSagaAction = createAction<UpdateSpacePayload>(
  'spaces/editSpaceSagaAction',
);
